import React from 'react';
import classNames from 'classnames';


const FilterSection = ({ title, children, justify = 'start' }) => {
    const containerClasses = classNames(
        'flex flex-wrap w-full',
        'gap-x-3 gap-y-3',
        {
            'justify-start': justify === 'start',
            'justify-center': justify === 'center',
            'justify-around': justify === 'around',
        }
    );

    return (
        <div className="flex flex-col items-start w-full my-3">
            <h3 className="text-base font-semibold text-white mb-3">{title}</h3>
            <div className={containerClasses}>{children}</div>
        </div>
    );
};

export default FilterSection;
